import boxIcon from "../assets/icons/box.png";
import CustomButton from "./Form/CustomButton";

const NotFound = ({
  text1,
  text2,
  onClick,
  isButton = false,
  buttonText = "ADD YOUR FIRST PROPERTY",
  className = "bg-[#873FE2] text-white border-[#873FE2] w-[190px] h-[30px] mt-2 rounded-[3.77px] uppercase text-[12px] font-[500] font-inter leading-[100%] ",
  hoverEffect = "none",
}) => {
  return (
    <div
      className="font-inter text-[15px] text-[rgb(112,112,112)] flex flex-col gap-[10px] items-center justify-center py-9 w-full bg-white rounded-[10px]"
      style={{ boxShadow: "0px 4px 4px 0px #0000000F" }}
    >
      <img src={boxIcon} className="w-[38px] h-[38px]" alt="" />
      <p>{text1 || "No support requests found"}</p>
      <p>
        {text2 || "No support requests match your current filter criteria."}
      </p>
      {isButton && (
        <CustomButton
          onClick={onClick}
          buttonText={buttonText}
          type="submit"
          hoverEffect={hoverEffect}
          className={className}
        />
      )}
    </div>
  );
};

export default NotFound;
